export default __webpack_public_path__ + "static/grafika_grupy-c45874783b104cf9384360c9f3d47ed0.png";